import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useContext, useEffect, useState } from "react";
import { APIContext } from '../Contexts/APIContext';
import Paper from "@mui/material/Paper";
import DropDownViewModel from "../Utilities/ViewModels/DropDownViewModel";
import { TelemetryContext, extractTelemetryFileName } from "../Contexts/TelemetryContext";

interface IProps {
    tableType: string;
    title: string
}

export default function ResearchReportTable(props: IProps) {
    const { get } = useContext(APIContext);
    const { logFileAccess } = useContext(TelemetryContext);
    const [fileNames, setFileNames] = useState<DropDownViewModel[]>([]);

    useEffect(() => {
        get('Document', `GetTableFiles?folder=${props.tableType}`, setFileNames);
    }, []);

    const getFile = (selectedFile: string) => {
        logFileAccess(extractTelemetryFileName(selectedFile), "ResearchReport");
        window.open(selectedFile ?? '', "_blank");
    };

    return (
        <TableContainer component={Paper}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>{props.title}</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {fileNames.map((file, index) => (
                        <TableRow key={file.id + index}>
                            <TableCell>
                                {file.label}
                            </TableCell>
                            <TableCell>
                                <Button size="small" onClick={() => getFile(file.id)}>View</Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
